(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["dar-fbt"] && !Shopify.designMode) return;
  try {
    /* Total dinamico + anadir todo de una.
     Se delega en document porque Horizon vuelve a pintar el bloque al cambiar de
     variante: un listener atado al nodo original se perderia. */
  (function () {
    if (window.__darFbt) return;
    window.__darFbt = true;

    function fmt(cents, sample) {
      // Se reusa el formato que Liquid ya imprimio en la pagina (simbolo,
      // separadores y posicion) en vez de inventar uno en JS.
      var m = (sample || '').match(/^([^\d]*)([\d.,]+)([^\d]*)$/);
      var n = (cents / 100).toFixed(2);
      if (!m) return n;
      var usaComa = m[2].indexOf(',') > m[2].indexOf('.');
      if (usaComa) n = n.replace('.', ',');
      return m[1] + n + m[3];
    }

    function recalc(root) {
      var total = 0;
      root.querySelectorAll('[data-fbt-item]').forEach(function (i) {
        if (i.checked) total += parseInt(i.getAttribute('data-price'), 10) || 0;
      });
      var el = root.querySelector('[data-fbt-total]');
      if (el) {
        if (!el.dataset.sample) el.dataset.sample = el.textContent.trim();
        el.textContent = fmt(total, el.dataset.sample);
      }
      var btn = root.querySelector('[data-fbt-add]');
      if (btn) btn.disabled = total === 0;
    }

    document.addEventListener('change', function (e) {
      var i = e.target.closest('[data-fbt-item]');
      if (!i) return;
      var root = i.closest('[data-fbt]');
      if (root) recalc(root);
    });

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-fbt-add]');
      if (!btn) return;
      var root = btn.closest('[data-fbt]');
      var msg = root.querySelector('[data-fbt-msg]');
      var items = [];
      root.querySelectorAll('[data-fbt-item]').forEach(function (i) {
        if (i.checked) items.push({ id: parseInt(i.getAttribute('data-variant'), 10), quantity: 1 });
      });
      if (!items.length) return;

      var original = btn.textContent;
      btn.disabled = true;
      btn.textContent = btn.getAttribute('data-loading') || 'Adding...';

      var root_url = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root_url.replace(/\/$/, '') + '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.d.description || res.d.message || 'error');
          if (msg) { msg.hidden = false; msg.className = 'dar-fbt__msg is-ok'; msg.textContent = btn.getAttribute('data-ok') || 'Added to your cart.'; }
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { source: 'dar-fbt' } }));
        })
        .catch(function (err) {
          if (msg) { msg.hidden = false; msg.className = 'dar-fbt__msg is-err'; msg.textContent = err.message; }
        })
        .then(function () {
          // se restaura SIEMPRE, tambien si fallo: si no, el boton queda muerto
          btn.disabled = false;
          btn.textContent = original;
        });
    });

    function boot() { document.querySelectorAll('[data-fbt]').forEach(recalc); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["dar-variant-measures"] && !Shopify.designMode) return;
  try {
    // Enseña las medidas de la variante elegida. No depende de eventos propios del
  // tema: mira el input oculto `name="id"` del formulario, que es lo que Shopify
  // actualiza siempre al cambiar de variante, con independencia del tema.
  class DarVariantMeasures extends HTMLElement {
    connectedCallback() {
      this.bloques = this.querySelectorAll('.dar-vm__set');
      if (!this.bloques.length) return;

      this.input =
        (this.closest('form') || document).querySelector('input[name="id"]') ||
        document.querySelector('input[name="id"]');
      if (!this.input) return;

      this.aplicar = () => this.mostrar(this.input.value);
      // El picker cambia el `value` por propiedad y por atributo segun el caso,
      // asi que se vigilan las dos vias mas el evento change.
      this.observer = new MutationObserver(this.aplicar);
      this.observer.observe(this.input, { attributes: true, attributeFilter: ['value'] });
      this.input.addEventListener('change', this.aplicar);
      document.addEventListener('change', this.aplicar, true);
      this.aplicar();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.input) this.input.removeEventListener('change', this.aplicar);
      document.removeEventListener('change', this.aplicar, true);
    }

    mostrar(id) {
      if (!id) return;
      let alguno = false;
      this.bloques.forEach((b) => {
        const suya = b.dataset.variant === String(id);
        b.hidden = !suya;
        if (suya) alguno = true;
      });
      // Talla sin medidas en el origen: no se enseña nada, ni una tabla vacia.
      this.hidden = !alguno;
    }
  }

  if (!customElements.get('dar-variant-measures')) {
    customElements.define('dar-variant-measures', DarVariantMeasures);
  }
  } catch(e) { console.error(e); }
})();

})();
